import { Eyebrow, Reveal } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/data/content";

const Process = () => (
  <section id="sa-fungerar-det" className="bg-navy pb-20 sm:pb-28">
    <div className="mx-auto max-w-7xl border-t border-white/10 px-5 pt-16 sm:px-8 sm:pt-20">
      <Reveal className="max-w-2xl">
        <Eyebrow>Processen</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">Så fungerar det</h2>
        <p className="mt-4 text-base text-cream/60 sm:text-lg">
          Från första kontakt till lansering – en tydlig process utan krångel.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        {PROCESS_STEPS.map((s, i) => (
          <Reveal key={s.step} delay={i * 0.08}>
            <div data-testid={s.testId} className="relative border-t-2 border-white/10 pt-6">
              <span aria-hidden="true" className="absolute -top-0.5 left-0 h-0.5 w-12 bg-teal" />
              <span className="font-display text-4xl font-extrabold tracking-tight text-orange">{s.step}</span>
              <h3 className="mt-3 font-display text-lg font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/60">{s.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
